export default __webpack_public_path__ + "static/media/benutzerIcon.632944f2.svg";